import {
  Emoji,
  Group,
  HeadlineSuggestions,
  Input,
} from 'apps/shared/scripts/components';

import { Step, StepProps } from '../../components';
import { FORM_FIELDS } from '../../components/OnboardingForm';
import { useOnNextStep } from '../../hooks';

import { emojiPickerClassName, suggestionsClassName } from './styles';

type Props = Omit<StepProps, 'heading' | 'subheading' | 'name' | 'percentage'>;

const SUGGESTIONS: string[] = [
  'Happy birthday! 🍰',
  'Congrats! 🎉',
  'Good luck ☘️',
  'Feel better soon ❤️',
  'Welcome onboard 👨‍💻',
];

const OnboardingHeadlineContainer = (props: Props) => {
  const { onKeyDown } = useOnNextStep({
    ...props,
    name: FORM_FIELDS.HEADLINE.name,
  });
  return (
    <Step
      {...props}
      heading="What is the occasion?"
      subheading="This is the headline that will appear in the card header"
      name={FORM_FIELDS.HEADLINE.name}
      percentage={50}
    >
      <Group errors={props.errors} validate={FORM_FIELDS.HEADLINE.name}>
        <Emoji
          emojiPickerClassName={emojiPickerClassName}
          control={props.control}
          name={FORM_FIELDS.HEADLINE.name}
        >
          <Input
            control={props.control}
            name={FORM_FIELDS.HEADLINE.name}
            onKeyDown={onKeyDown}
          />
        </Emoji>
      </Group>
      <HeadlineSuggestions
        className={suggestionsClassName}
        control={props.control}
        name={FORM_FIELDS.HEADLINE.name}
        suggestions={SUGGESTIONS}
      />
    </Step>
  );
};

OnboardingHeadlineContainer.displayName = 'OnboardingHeadlineContainer';

export default OnboardingHeadlineContainer;
